import { createFileRoute } from '@tanstack/react-router';
import Countries from '../../../features/baseData/countries/countries';
import {
  COUNTRIES_PERMISSIONS,
  createPermissionGuard,
  getPermissionSet,
} from '@bmwe/ui';

export const Route = createFileRoute('/stammdaten/laender/')({
  component: Countries,
  beforeLoad: createPermissionGuard(
    getPermissionSet(COUNTRIES_PERMISSIONS, 'READ'),
  ),
});

export const ListCountriesRoute = Route;
